import script from "./real-time-player.vue?vue&type=script&setup=true&lang=ts"
export * from "./real-time-player.vue?vue&type=script&setup=true&lang=ts"

import "./real-time-player.vue?vue&type=style&index=0&id=5e430e1e&lang=scss"

const __exports__ = script;

export default __exports__